<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div
                            v-if="datos.cumplimiento==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h3 v-else>
                           {{datos.cumplimiento}} %
                        </h3>
                        <h6 class="card-subtitle">
                          {{ $t("page.content_dashboard.cards.participante.cumplimiento") }}
                        </h6>
                    </div>
                    <div class="col-12">
                        <div class="progress">
                            <div
                                id="porcentaje_cumplimiento"
                                class="progress-bar bg-success"
                                role="progressbar"
                                :aria-valuenow="datos.cumplimiento" aria-valuemin="0"
                                aria-valuemax="100" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center pointerCursor" v-on:click="$router.push({name:'Consultar_Plan_Capacitacion', params:{location:'pendientes'}})">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-lg fa-laptop"></i>
                        </h2>
                    </div>
                    <div class="col-6 text-center pt-3">
                        <h5
                          class="card-subtitle"
                          style="cursor:pointer;"
                        >
                          {{ $t("page.content_dashboard.cards.participante.cursos_pendientes") }}
                      </h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="datos.cursos_pendientes==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1 v-else>{{datos.cursos_pendientes}}</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center pointerCursor" v-on:click="$router.push({name:'Consultar_Plan_Capacitacion', params:{location:'completados'}})">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-clipboard-check"></i>
                        </h2>
                    </div>
                    <div class="col-6 text-center pt-3">
                        <h5 class="card-subtitle">
                          {{ $t("page.content_dashboard.cards.participante.cursos_terminados") }}
                        </h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="datos.cursos_terminados==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1 v-else>{{datos.cursos_terminados}}</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-trophy"></i>
                        </h2>
                    </div>
                    <div class="col-auto text-center pt-4">
                        <h5 class="card-subtitle">
                          {{ $t("page.content_dashboard.cards.participante.mi_ranking") }}
                        </h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="rankingCargando"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1 v-else-if="rankingError">—</h1>
                        <h1 v-else>{{ datos.mi_ranking }}</h1>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import {mapActions} from 'vuex';

export default {
    data(){
        return {
            datos:{
                mi_ranking: 0,
                cursos_pendientes: null,
                cursos_terminados:null,
                cumplimiento: null
            },
            rankingCargando: true,
            rankingError: false
        }
    },
    methods:{
        parseJsonResponse(respuesta){
            if (respuesta && respuesta.body !== undefined && respuesta.body !== null && respuesta.body !== '') {
                return respuesta.body;
            }
            if (respuesta && typeof respuesta.json === 'function') {
                return respuesta.json();
            }
            return respuesta;
        },
        Consultar(){
            var that = this;
            this.$http.get('dashboard/cards')
            .then(respuesta => this.parseJsonResponse(respuesta))
            .then(respuestaJson=>{
                this.datos.cursos_pendientes = respuestaJson.cursos_pendientes;
                this.datos.cursos_terminados = respuestaJson.cursos_terminados;
                this.datos.cumplimiento = respuestaJson.cumplimiento;
                if (respuestaJson.mi_ranking !== undefined && respuestaJson.mi_ranking !== null) {
                    this.datos.mi_ranking = respuestaJson.mi_ranking;
                    this.rankingCargando = false;
                    this.rankingError = false;
                }
                $(document).ready(function(){
                    $('#porcentaje_cumplimiento').width(that.datos.cumplimiento+'%');
                });
            })
            .catch(()=>{
                this.datos={
                    mi_ranking: 0,
                    cursos_pendientes: 0,
                    cursos_terminados:0,
                    cumplimiento: 0
                };
                this.rankingCargando = false;
                this.rankingError = true;
            });
        },
        ConsultarRanking(){
            this.rankingCargando = true;
            this.rankingError = false;
            this.$http.get('dashboard/mi-ranking', { timeout: 120000 })
            .then(respuesta => this.parseJsonResponse(respuesta))
            .then(respuestaJson=>{
                const rank = respuestaJson && respuestaJson.mi_ranking;
                this.datos.mi_ranking = rank !== undefined && rank !== null ? rank : 0;
                this.rankingCargando = false;
                this.rankingError = false;
            })
            .catch(()=>{
                this.datos.mi_ranking = 0;
                this.rankingCargando = false;
                this.rankingError = true;
            });
        }
    },
    mounted(){
        this.Consultar();
        this.ConsultarRanking();
    }
};
</script>

<style scoped>
.pointerCursor{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Participante.vue